import { isWeb } from '../storage';
import { NativeModules } from 'react-native';

let secretKeyString: string | null = null;
let initPromise: Promise<void> | null = null;

const getEncryptedKeyFromNative = async (): Promise<string> => {
  const key = await NativeModules.EncryptedKeyModule.getEncryptedKey();
  return key;
};

export const initSecretKey = (): Promise<void> => {
  if (!initPromise) {
    initPromise = getEncryptedKeyFromNative()
      .then((key) => {
        secretKeyString = key;
      })
      .catch((e) => {
        console.error('Failed to get key from native module:', e);
        throw e;
      });
  }
  return initPromise;
};

export const getSecretKey = (): string => {
  if (isWeb) return 'Rb-Rogers-SelfserveEncryptionKey';
  if (secretKeyString === null) {
    throw new Error('Secret key not initialized. Call initSecretKey() first.');
  }
  return secretKeyString;
};
